import { useTranslation } from 'react-i18next';

import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

export const useGetAccountsColumns = () => {
  const { t } = useTranslation();

  return [
    { field: 'accountName', flex: 1, headerName: t('accountName') },
    { field: 'nameLast', flex: 1, headerName: t('firstName') },
    { field: 'nameFirst', flex: 1, headerName: t('lastName') },
    { field: 'comEmail', flex: 1, headerName: t('email') },
    {
      field: 'valid.from',
      type: 'date',
      headerName: t('validFrom'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      minWidth: 120
    },
    {
      field: 'valid.to',
      type: 'date',
      headerName: t('validTo'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      minWidth: 120
    }
  ];
};
